<ion-modal
  [isOpen]="isOpen"
  class="live-code-scanner-modal"
  [backdropDismiss]="false"
  [canDismiss]="!isRegistering()"
  (didPresent)="scannerDidPresent()"
  (didDismiss)="scannerDidDismiss()">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ mode === 'search' ? 'コード検索' : mode === 'collect' ? 'コードをスキャン' : '関連部品登録' }}</ion-title>
        <ion-buttons slot="end">
          <ion-button
            aria-label="キャンセルして閉じる"
            [disabled]="isRegistering()"
            (click)="cancelScanner()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="scanner-content" [scrollY]="false">
      <div class="scanner-layout">
        <div class="camera-frame" [class.detected]="hasRecentDetection">
          <video
            #scannerVideo
            autoplay
            muted
            playsinline
            aria-label="コード読み取り用カメラ映像"
            (playing)="onVideoPlaying()"
            (stalled)="onVideoPlaybackProblem('stalled')"
            (error)="onVideoPlaybackProblem('error')">
          </video>
          <div class="scan-guide" aria-hidden="true"></div>
        </div>

        <canvas #scannerCanvas class="decode-canvas" aria-hidden="true"></canvas>

        <section class="zoom-control" *ngIf="zoomSupported">
          <div class="zoom-heading">
            <strong>カメラズーム</strong>
            <span>{{ zoomCurrent }}×</span>
          </div>
          <ion-range
            aria-label="カメラズーム"
            [min]="zoomMin"
            [max]="zoomMax"
            [step]="zoomStep"
            [value]="zoomCurrent"
            [pin]="true"
            (ionInput)="onZoomChange($event)">
          </ion-range>
        </section>

        <ion-text color="danger" *ngIf="userErrorMessage">
          <p class="user-error">{{ userErrorMessage }}</p>
        </ion-text>
        <ion-text color="danger" *ngIf="registrationError()">
          <p class="user-error">{{ registrationError() }}</p>
        </ion-text>

        <p class="search-guide" *ngIf="mode === 'search'">検索するコードを読み取ってください</p>

        <section class="scan-results" aria-live="polite" *ngIf="mode !== 'search'">
          <div class="result-heading">
            <strong>読み取り済み（{{ scannedCodes().length }}件）</strong>
          </div>
          <ion-list class="scan-results-list" *ngIf="scannedCodes().length > 0; else noResults">
            <ion-item-sliding *ngFor="let code of displayedScannedCodes" #codeSliding>
              <ion-item>
                <ion-icon name="checkmark-circle" color="success" slot="start"></ion-icon>
                <ion-label>
                  <div class="code-value">{{ code }}</div>
                  <p *ngIf="getScannedCodeFormat(code) as format">{{ format }}</p>
                </ion-label>
              </ion-item>
              <ion-item-options side="end">
                <ion-item-option color="danger" (click)="removeScannedCode(code, codeSliding)">
                  削除
                </ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          </ion-list>
          <ng-template #noResults>
            <p class="empty-results">2回一致したコードがここに確定表示されます。</p>
          </ng-template>
        </section>
      </div>
    </ion-content>

    <ion-footer>
      <ion-toolbar>
        <ion-buttons class="scanner-actions app-footer-actions">
          <ion-button
            fill="outline"
            [disabled]="isRegistering()"
            (click)="cancelScanner()">
            キャンセル
          </ion-button>
          <ion-button
            *ngIf="mode === 'register'"
            color="primary"
            fill="solid"
            [disabled]="scannedCodes().length === 0 || isRegistering() || jobId === null"
            (click)="registerRelatedPart()">
            <ion-spinner *ngIf="isRegistering()" name="crescent"></ion-spinner>
            <span>{{ isRegistering() ? '登録中...' : '関連部品として登録' }}</span>
          </ion-button>
          <ion-button
            *ngIf="mode === 'collect'"
            color="primary"
            fill="solid"
            [disabled]="isRegistering()"
            (click)="completeCollection()">
            完了（{{ scannedCodes().length }}件）
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
